export default {
  name: 'VAvatar',
  props: {
    user: {
      type: [Object]
    },
    to: {
      type: [String]
    }
  },
  data() {
    return {
      defaultIcon: require('@/assets/image/default-avatar.jpeg')
    };
  },
  mounted() {}
};